import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import LightningAnimation from './LightningAnimation';
import RainAnimation from './RainAnimation';

interface IconProps {
  className?: string;
}

function ThunderstormWithRainIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-thunderstorm-with-rain"
    >
      <path
        d="M55.0684 22C67.2823 22 77.1836 31.9013 77.1836 44.1152C77.1836 44.5608 77.1695 45.0033 77.1436 45.4424H84.3457C93.6283 45.4424 101.154 52.9674 101.154 62.25C101.154 71.5325 93.6282 79.0576 84.3457 79.0576H34.8076C25.5251 79.0576 18.0002 71.5325 18 62.25C18 53.5784 24.5669 46.4402 32.999 45.5381C32.9691 45.0676 32.9531 44.5932 32.9531 44.1152C32.9531 31.9012 42.8544 22 55.0684 22Z"
        fill="white"
        fillOpacity="0.7"
      >
        <FloatAnimation />
      </path>
      <g filter="url(#filter1_d_thunderstorm_rain)">
        <LightningAnimation />
        {/* lightning */}
        <path
          d="M60 79.2766L72.1465 54L71.0743 70.8511H81L68.8535 98L70.1185 79.2766H60Z"
          fill="#FFA51F"
        />
      </g>
      <path
        d="M35.1477 75.3516C35.5058 74.6046 36.4017 74.2894 37.1487 74.6475C37.8956 75.0056 38.2108 75.9014 37.8528 76.6484L34.3528 83.9512C33.9947 84.6981 33.0988 85.0133 32.3518 84.6553C31.6049 84.2972 31.2897 83.4013 31.6477 82.6543L35.1477 75.3516Z"
        fill="white"
      >
        <RainAnimation />
      </path>
      <path
        d="M50.6477 75.3516C51.0058 74.6046 51.9017 74.2894 52.6487 74.6475C53.3956 75.0056 53.7108 75.9014 53.3528 76.6484L49.8528 83.9512C49.4947 84.6981 48.5988 85.0133 47.8518 84.6553C47.1049 84.2972 46.7897 83.4013 47.1477 82.6543L50.6477 75.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.3} />
      </path>
      <path
        d="M40.1477 86.3516C40.5058 85.6046 41.4017 85.2894 42.1487 85.6475C42.8956 86.0056 43.2108 86.9014 42.8528 87.6484L39.3528 94.9512C38.9947 95.6981 38.0988 96.0133 37.3518 95.6553C36.6049 95.2972 36.2897 94.4013 36.6477 93.6543L40.1477 86.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.6} />
      </path>
      <path
        d="M55.6477 86.3516C56.0058 85.6046 56.9017 85.2894 57.6487 85.6475C58.3956 86.0056 58.7108 86.9014 58.3528 87.6484L54.8528 94.9512C54.4947 95.6981 53.5988 96.0133 52.8518 95.6553C52.1049 95.2972 51.7897 94.4013 52.1477 93.6543L55.6477 86.3516Z"
        fill="white"
      >
        <RainAnimation delay={0.9} />
      </path>
      <defs>
        <filter
          id="filter1_d_thunderstorm_rain"
          x="44"
          y="38"
          width="53"
          height="76"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(ThunderstormWithRainIcon);
